import { HTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";
import { usePalette } from "@/shared/theme";

type SectionProps = {
  section?: boolean;
  bgColor?: string;
} & HTMLAttributes<HTMLElement>;

export const SectionComponent = (props: SectionProps) => {
  const palette = usePalette();
  const {
    children,
    section,
    bgColor = `linear-gradient(to bottom, ${palette.primary[5]} 0%, ${palette.primary[7]}  84.79%, ${palette.primary[8]} 100%`,
    className,
    ...args
  } = props;

  return (
    <div
      style={{
        background: bgColor,
      }}
    >
      <section
        {...args}
        className={twMerge(
          section &&
            "flex items-center justify-center flex-1 min-h-dvh container",
          className,
        )}
      >
        {children}
      </section>
    </div>
  );
};
